import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';


import Card from '../components/Card';


import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';

import ButtonGroup from '../components/ButtonGroup';
import InsulatedButton from '../components/InsulatedButton';


import { createCalculation, CALCULATION_TYPE_PLANE, CALCULATION_TYPE_PIPE, CALCULATION_TYPE_DUCT, CALCULATION_TYPE_TANK, CALCULATION_TYPE_CIRCULAR_DUCT, CALCULATION_TYPE_RECTANGULAR_DUCT, CALCULATION_TYPE_VERTICAL_TANK, CALCULATION_TYPE_HORIZONTAL_TANK, CALCULATION_TYPE_RECTANGULAR_TANK, INITIAL_STATE } from '../modules/calculation';

import { getUIText } from '../utils/index';

class NewCalculationDialog extends Component {

  constructor(props) {
    super(props);
    const { project } = this.props;
    this.state = {
      calculationName: 'Calc ' + (project.calculations.length + 1),
      insulatedObjectType: CALCULATION_TYPE_PLANE,
    };
  }

  onCalculationNameChange = (calculationName) => {
    this.setState({ calculationName });
  };

  insulatedObjectTypeButtonGroupOnChange = (item) => {
    if(item === CALCULATION_TYPE_DUCT) {
      if(this.state.insulatedObjectType === CALCULATION_TYPE_RECTANGULAR_DUCT) {
        return;
      }
      item = CALCULATION_TYPE_CIRCULAR_DUCT;
    } else if(item === CALCULATION_TYPE_TANK) {
      if(this.state.insulatedObjectType === CALCULATION_TYPE_HORIZONTAL_TANK || this.state.insulatedObjectType === CALCULATION_TYPE_RECTANGULAR_TANK) {
        return;
      }
      item = CALCULATION_TYPE_VERTICAL_TANK;
    }

    this.setState({insulatedObjectType: item});
  };

  insulatedObjectTypeSubButtonGroupOnChange = (item) => {
    this.setState({insulatedObjectType: item});
  };

  render() {
    const { project, onCreateProjectClick, app, translations } = this.props;
    const { calculationName, insulatedObjectType } = this.state;

    let subButtonGroup;

    if(insulatedObjectType === 'tank' || insulatedObjectType === CALCULATION_TYPE_VERTICAL_TANK || insulatedObjectType === 'horizontal-tank' || insulatedObjectType === 'rectangular-tank') {
      subButtonGroup = (<ButtonGroup className="animated fadeIn" onChange={this.insulatedObjectTypeSubButtonGroupOnChange}>
        <InsulatedButton label={getUIText('CALCULATION-CIRCULAR_TANK', app.language, translations)} selected={insulatedObjectType === CALCULATION_TYPE_VERTICAL_TANK ? true : false} type={CALCULATION_TYPE_VERTICAL_TANK} />
        <InsulatedButton label={getUIText('CALCULATION-CIRCULAR_TANK', app.language, translations)} selected={insulatedObjectType === CALCULATION_TYPE_HORIZONTAL_TANK ? true : false} type={CALCULATION_TYPE_HORIZONTAL_TANK} />
        <InsulatedButton label={getUIText('CALCULATION-RECTANGULAR_TANK', app.language, translations)} selected={insulatedObjectType === 'rectangular-tank' ? true : false} type="rectangular-tank" />
      </ButtonGroup>);
    } else if((insulatedObjectType === CALCULATION_TYPE_DUCT || insulatedObjectType === CALCULATION_TYPE_CIRCULAR_DUCT || insulatedObjectType === CALCULATION_TYPE_RECTANGULAR_DUCT)) {
      subButtonGroup = (<ButtonGroup className="animated fadeIn" onChange={this.insulatedObjectTypeSubButtonGroupOnChange} >
        <InsulatedButton label={getUIText('CALCULATION-CIRCULAR_DUCT', app.language, translations)} selected={insulatedObjectType === CALCULATION_TYPE_CIRCULAR_DUCT ? true : false} type={CALCULATION_TYPE_CIRCULAR_DUCT} />
        <InsulatedButton label={getUIText('CALCULATION-RECTANGULAR_DUCT', app.language, translations)} selected={insulatedObjectType === CALCULATION_TYPE_RECTANGULAR_DUCT ? true : false} type={CALCULATION_TYPE_RECTANGULAR_DUCT} />
      </ButtonGroup>);
    }

    const createButtonText = getUIText('CALCULATION-CREATE', app.language, translations);

    return (
      <div className="m-container">
        <Card title={getUIText('CALCULATION-CREATE_NEW_CALCULATION', app.language, translations)} className="card-new-calculation" iconClass="fa fa-plus-square">
          <label className="input-header">{getUIText('CALCULATION-CALCULATION_NAME', app.language, translations)}</label>
          <Input className="input"
            value={calculationName}
            onChange={event => this.onCalculationNameChange(event.target.value)} />
          <div className="insulated-object">
            <div className="insulated-object-header">{getUIText('CALCULATION-SELECT_OBJECT', app.language, translations)}</div>
            <ButtonGroup onChange={this.insulatedObjectTypeButtonGroupOnChange} >
              <InsulatedButton label={getUIText('CALCULATION-FLAT_SURFACE', app.language, translations)} selected={insulatedObjectType === CALCULATION_TYPE_PLANE ? true : false} type={CALCULATION_TYPE_PLANE} />
              <InsulatedButton label={getUIText('CALCULATION-PIPE', app.language, translations)} selected={insulatedObjectType === CALCULATION_TYPE_PIPE ? true : false} type={CALCULATION_TYPE_PIPE} />
              <InsulatedButton label={getUIText('CALCULATION-DUCT', app.language, translations)} selected={(insulatedObjectType === CALCULATION_TYPE_DUCT || insulatedObjectType === CALCULATION_TYPE_CIRCULAR_DUCT || insulatedObjectType === CALCULATION_TYPE_RECTANGULAR_DUCT) ? true : false} type={CALCULATION_TYPE_DUCT} />
              <InsulatedButton label={getUIText('CALCULATION-TANKS', app.language, translations)} selected={(insulatedObjectType === CALCULATION_TYPE_TANK || insulatedObjectType === CALCULATION_TYPE_VERTICAL_TANK || insulatedObjectType === CALCULATION_TYPE_HORIZONTAL_TANK || insulatedObjectType === CALCULATION_TYPE_RECTANGULAR_TANK ) ? true : false} type={CALCULATION_TYPE_TANK} />
            </ButtonGroup>
            {subButtonGroup}
          </div>
          <div>
            {/* createButtonText ? <ButtonWithIcon icon="fa fa-plus-circle" onClick={() => onCreateProjectClick({ ...INITIAL_STATE, name: calculationName, type: insulatedObjectType})} label={createButtonText} /> : null*/}
            <Button color="primary" className="mt-2"  onClick={() => onCreateProjectClick({ ...INITIAL_STATE, name: calculationName, type: insulatedObjectType})} >
              <i className="fa fa-plus mr-2"/>{createButtonText}
            </Button>
          </div>
        </Card>
      </div>
    );
  }
}

NewCalculationDialog.propTypes = {
    project: PropTypes.object,
    translations: PropTypes.object,
    app: PropTypes.object,
  onCreateProjectClick: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
      project: state.project,
      translations: state.translations,
      app: state.app,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      onCreateProjectClick: (calc) => dispatch(createCalculation(calc))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(NewCalculationDialog);
